import { MantineTheme, MantineThemeOverride, useMantineTheme } from "@mantine/core";
import { useAtomValue } from "jotai";
import { pxToRem } from "theme";

import { themeConfigAtom } from "atoms/clientConfig";

export const useGetThemeOverride = () => {
  const { font, colours, buttons } = useAtomValue(themeConfigAtom);
  const { gradient } = buttons;
  const theme = useMantineTheme();

  const primary = {
    5: theme.fn.lighten(colours.primary, 0.95),
    10: theme.fn.lighten(colours.primary, 0.825),
    30: theme.fn.lighten(colours.primary, 0.65),
    60: colours.primary,
    80: theme.fn.darken(colours.primary, 0.4),
  };

  const themeOverride: MantineThemeOverride = {
    fontFamily: font.family,
    other: { pxToRem, primary },
  };

  const stylesOverride = {
    Button: (theme: MantineTheme) => ({
      gradient: gradient
        ? {
            background: theme.fn.linearGradient(gradient.deg, gradient.from, gradient.to),
          }
        : {},
    }),
  };

  return { themeOverride, stylesOverride };
};
